export default __webpack_public_path__ + "static/media/FrequentlyAskedQuestions.aaf92164.jpg";